import Alpine from "alpinejs";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const headingAnimation = () => {
  Alpine.data("headingAnimation", () => ({
    timeline: null as gsap.core.Timeline | null,
    init() {
      const root = this.$root as HTMLElement;
      const dot = root.querySelector(".js-heading-dot") as HTMLElement | null;
      const chars = Array.from(root.querySelectorAll(".js-heading-char")) as HTMLElement[];
      const jaLabel = root.querySelector(".js-heading-ja") as HTMLElement | null;

      if (!dot && chars.length === 0 && !jaLabel) return;

      gsap.set(dot, { autoAlpha: 0, scale: 1.5, transformOrigin: "50% 50%" });
      gsap.set(chars, { autoAlpha: 0, x: 16 });
      gsap.set(jaLabel, { autoAlpha: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: "top 80%",
          once: true,
        },
      });

      tl.to(dot, {
        autoAlpha: 1,
        scale: 1,
        duration: 0.6,
        ease: "power2.out",
      })
        .to(
          chars,
          {
            x: 0,
            autoAlpha: 1,
            duration: 0.6,
            stagger: 0.05,
            ease: "power2.out",
          },
          "<",
        )
        .to(
          jaLabel,
          {
            autoAlpha: 1,
            duration: 1.6,
            ease: "power2.out",
          },
          "-=0.6",
        );

      this.timeline = tl;
    },
    destroy() {
      this.timeline?.scrollTrigger?.kill();
      this.timeline?.kill();
      this.timeline = null;
    },
  }));
};
